import { render, staticRenderFns } from "./UpgradeCell.vue?vue&type=template&id=4ae10d9c&lang=pug"
import script from "./UpgradeCell.vue?vue&type=script&lang=js"
export * from "./UpgradeCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports